import React from 'react';

export const ProgramSummaryCard = ({ program, heading }) => {
    if (!program) return null;

    return (
        <div className="card border">
            {heading && (
                <div className="card-header small text-muted font-weight-bold text-uppercase">
                    {heading}
                </div>
            )}
            <div className="card-body small">
                <p className="card-title font-weight-bold mb-1">{program.programFormalName}</p>
                <p className="mb-0 text-muted">ID: {program.programId}</p>
                {program.programStatusDesc && (
                    <p className="mb-0">Status: {program.programStatusDesc}</p>
                )}
                {program.cipSixDigitCode && (
                    <p className="mb-0">CIP: {program.cipSixDigitCode}</p>
                )}
                {(program.programCreditReqMin != null || program.programCreditReqMax != null) && (
                    <p className="mb-0">
                        Credits: {program.programCreditReqMin}–{program.programCreditReqMax}
                    </p>
                )}
                {program.deliveryModeLabel && (
                    <p className="mb-0">Delivery: {program.deliveryModeLabel}</p>
                )}
            </div>
        </div>
    );
};
